export default "__VITE_ASSET__ClS2o1bG__"